


















































































































































import { getLogoPath } from "@/stores/webmaster/finance/modal/helpers/paymentSystemsLogo";
import { formatCurrency } from "@core/filters";
import { computed, onMounted, onUnmounted, ref, watch } from "@vue/composition-api";
import { storeToRefs } from "pinia";
import i18nPlugin from "@core/plugins/i18n";
import _debounce from "lodash/debounce";
import { useWait } from "@/stores/common/waitStore";
import { useRequisiteStore } from "@/stores/webmaster/finance/modal/requisiteStore";
import { actionWithToast } from "@/helpers/actionWithToast";
import { defineExpose } from "@vue/runtime-dom";
import { DialogProgrammatic } from "buefy";
import { useFinancePaymentModal } from "@/stores/webmaster/finance/modal/financePaymentModal";
import { useUser } from "@/stores/common/profile/user";
import FinancePaymentList from "@/components/Webmaster/Finance/modal/FinancePaymentModal/FinancePaymentList.vue";
import storeInstance from "@/store";
import router from "@/router";
import { PaymentSystemsListItem } from "@core/store/types/common/lists/PaymentSystemsListState";
import telegramIcon from "@/assets/Contacts/logo_telegram.svg";
import lightning from "@/assets/common/lightning.svg";
import InlineSvg from "vue-inline-svg";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const requisiteStore = useRequisiteStore();
  const {
    input,
    paymentSystems,
    data: requisites
  } = storeToRefs(requisiteStore);
  const financePaymentModalStore = useFinancePaymentModal();
  const {
    currentTab
  } = storeToRefs(financePaymentModalStore);
  onMounted(async () => {
    if (!requisites.value?.items) {
      requisiteStore.GET_REQUISITES();
    }
    if (!paymentSystems.value?.items) {
      await requisiteStore.GET_PAYMENT_SYSTEMS();
      const {
        requisite,
        ...query
      } = router.currentRoute.query;
      if (requisite) {
        input.value = {
          purse: router.currentRoute.query.requisite,
          paymentSystemId: paymentSystems.value.items?.find((item: PaymentSystemsListItem) => item.integrator.alias === "lm_cards")?.id
        };
        router.replace({
          query
        });
      }
    }
  });
  const isValidRequisite = ref(true);
  const isLoadingResend = ref(false);
  const isLoading = useWait(requisiteStore, "ADD_REQUISITE");
  const isConfirmed = storeInstance.state.auth.isConfirmed;
  const selectedPaymentSystem = computed(() => {
    return paymentSystems.value.items?.find((item: PaymentSystemsListItem) => item.id === input.value.paymentSystemId) || {};
  });
  const sortedPaymentSystems = computed(() => {
    return paymentSystems.value?.items?.slice().sort((a: PaymentSystemsListItem, b: PaymentSystemsListItem) => {
      const getPriority = (item: PaymentSystemsListItem) => {
        if (item.isDisabled) return 2;
        if (item.integrator.alias === "lm_cards") return 0;
        return 1;
      };
      return getPriority(a) - getPriority(b);
    });
  });
  const requisitesWithValidation = computed(() => {
    return ["zaley_cash", "tron", "lm_cards"];
  });
  const debounceValidate = computed(() => {
    return _debounce(validate, 600, {
      trailing: true
    });
  });
  const shouldValidate = computed(() => {
    return requisitesWithValidation.value.includes(selectedPaymentSystem.value?.integrator?.alias);
  });
  const fieldMessage = computed(() => {
    return shouldValidate.value && !isValidRequisite.value && input.value.purse?.length ? i18nPlugin.t(`webmaster.finances.paymentModal.requisite.validation.${selectedPaymentSystem.value?.integrator?.alias}Message`) : "";
  });
  const loadingValidate = useWait(requisiteStore, "VALIDATE_REQUISITE_BY_INTEGRATOR");
  async function validate() {
    if (shouldValidate.value) {
      isValidRequisite.value = await requisiteStore.VALIDATE_REQUISITE_BY_INTEGRATOR(selectedPaymentSystem.value?.integrator?.alias);
    } else {
      isValidRequisite.value = true;
    }
  }
  async function resendEmail() {
    try {
      isLoadingResend.value = true;
      await actionWithToast(storeInstance.dispatch("webmaster/profile/RESEND_EMAIL"), "common.mailConfirmation.resendEmail");
    } finally {
      isLoadingResend.value = false;
    }
  }
  async function submit() {
    if (fieldMessage.value === "") {
      await actionWithToast(requisiteStore.ADD_REQUISITE(), "webmaster.finances.paymentModal.requisite.messages.addRequisite");
      DialogProgrammatic.alert({
        message: `<div class="is-flex is-flex-direction-column is-align-items-start mt-6 px-5">
              <img
                  src="/email.svg"
                  alt="">
              <div class="mt-4">
                  <strong class="is-size-4">${i18nPlugin.t("webmaster.profile.modal.approveRequisite")}</strong> <br>
                  ${i18nPlugin.t("webmaster.profile.modal.sendMessageOnMail", {
          email: `<a>${useUser().user?.contact?.email}</a>
              </div>
              `
        })}
          </div> ` as string,
        confirmText: i18nPlugin.t("webmaster.finances.paymentModal.requisite.confirm") as string,
        dangerouslyUseHTMLString: true,
        type: "is-warning is-light",
        onConfirm: () => {
          currentTab.value = "payout";
        }
      });
    }
  }
  watch(() => input.value.paymentSystemId, value => {
    if (!value) {
      input.value.purse = null;
    }
    if (value && shouldValidate.value) {
      validate();
    }
  });
  onUnmounted(() => {
    input.value = {};
  });
  return Object.assign({
    getLogoPath,
    formatCurrency,
    useUser,
    telegramIcon,
    lightning,
    input,
    currentTab,
    isLoadingResend,
    isLoading,
    isConfirmed,
    selectedPaymentSystem,
    sortedPaymentSystems,
    debounceValidate,
    fieldMessage,
    loadingValidate,
    resendEmail
  }, {
    submit
  });
};
__sfc_main.components = Object.assign({
  FinancePaymentList,
  InlineSvg
}, __sfc_main.components);
export default __sfc_main;
